// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1e-1a","title":"styles-module--title--R320I","causes":"styles-module--causes--3z9RS"};